import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function availableHoursNotesReducer(
  state = InitialState.availableHoursNotes,
  action
) {
  switch (action.type) {
    case types.SAVE_AVAILABLE_HOURS_NOTE_SUCCESS:
    case types.UPDATE_AVAILABLE_HOURS_NOTE_SUCCESS:
    case types.REMOVE_AVAILABLE_HOURS_NOTE_SUCCESS:
    case types.LOAD_AVAILABLE_HOURS_NOTES_SUCCESS:
      return { ...state, [action.data.id]: action.data.availableHoursNotes };
    default:
      return state;
  }
}
